import React from 'react';

import { sortBy } from 'lodash';
import SessionGraphs, {
  GraphBlueprint,
  GraphOptions,
  GraphSeries,
  GraphPoint,
  GraphPlotband,
  GraphInstanceProps
} from '../index';
import { FormatDate } from '../../../../libs/time';
import { IEpxDepress } from '../../../../libs/apps/epxdepress';
import { CHART } from '../../../../config/colors';

const EpxDepressGraphs: React.FC<GraphInstanceProps> = (props): JSX.Element => {
  const graph: GraphBlueprint<IEpxDepress> = {
    name: 'Depression',
    config: {
      chart: {
        type: 'line'
      },
      xAxis: {
        type: 'category',
        tickmarkPlacement: 'on',
        title: {
          text: null
        }
      },
      yAxis: {
        title: {
          text: 'Mood Scale'
        },
        max: 10,
        min: 0
      },
      responsive: {}
    },
    draw: (sessions, currentOptions) => {
      const options: GraphOptions = {
        series: []
      };
      const series: GraphSeries = {
        type: 'line',
        name: 'Mood Rating',
        connectNulls: true
      };
      const data: GraphPoint[] = [];
      const plotBands: GraphPlotband[] = [];
      sessions = sortBy(sessions, (session) => session.time);
      for (const [i, session] of sessions.entries()) {
        data.push({
          id: String(session.id),
          name: FormatDate(session.time, 'MM/DD'),
          y: session.mood,
          x: i
        });
        if (session.mood === 0 || session.mood === 1) {
          plotBands.push({
            from: i - 0.1,
            to: i + 0.1,
            color: CHART.PLOT_BAND_DANGER
          });
        }
      }
      series.data = data;
      options.series = [series];
      options.xAxis = {
        ...currentOptions.xAxis,
        plotBands: plotBands
      };
      return options;
    }
  };
  return (
    <SessionGraphs<IEpxDepress>
      url="/data/data_by_range/"
      graphs={[graph]}
      {...props}
    />
  );
};

export default EpxDepressGraphs;
